import { atom } from "jotai";
import {
	applyTheme,
	getNextThemeMode,
	type ResolvedTheme,
	readThemeMode,
	type ThemeMode,
	writeThemeMode,
} from "../lib/theme";

export const themeHydratedAtom = atom(false);
export const themeModeAtom = atom<ThemeMode>("light");
export const resolvedThemeAtom = atom<ResolvedTheme>("light");

export const initializeThemeAtom = atom(null, (_get, set) => {
	const mode = readThemeMode();

	applyTheme(mode);
	set(themeHydratedAtom, true);
	set(themeModeAtom, mode);
	set(resolvedThemeAtom, mode);
});

export const setThemeModeAtom = atom(null, (_get, set, mode: ThemeMode) => {
	writeThemeMode(mode);
	applyTheme(mode);
	set(themeHydratedAtom, true);
	set(themeModeAtom, mode);
	set(resolvedThemeAtom, mode);
});

export const cycleThemeModeAtom = atom(null, (get, set) => {
	const nextMode = getNextThemeMode(get(themeModeAtom));
	set(setThemeModeAtom, nextMode);
});
